<template>
    <!-- <TheHaeder/> -->
    <section class="login">
        <div class="container">
            <el-card class="w-100 ">
                <el-row :gutter="30" class="d-flex align-center">
                    <el-col :lg="10" :sm="10" :xs="24">
                        <img src="~@/assets/images/Logo.svg" alt="" class="mx-auto d-block" width="300">
                    </el-col>
                    <router-view></router-view>
                </el-row>
            </el-card>
        </div>
    </section>
</template>
<style lang="scss">
    @import  '~@/assets/styles/variables';
    .login{
        // background-color: $brown;
        // background-color: $brown;
        .container {
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>